// src/utils/axiosInstance.js
import axios from 'axios';
import Swal from 'sweetalert2';

// 👉 accedemos al logout desde contexto
import { logoutSessionExpired } from '../contexts/logoutHelper';

const instance = axios.create({
  baseURL: 'https://whiskyandco.com.ar',
});

// 📌 Interceptor de respuestas
instance.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;

    if (status === 403) {
      logoutSessionExpired(); // 🔐 cierre automático
    }

    return Promise.reject(error);
  }
);

export default instance;
